const cdAppSettings = {
  baseUrl: "",
  apiUrl: "/cloud-diagrams/api",
  doitPlatform2: "", // NOTE: use it for testing purposes only
};

export default cdAppSettings;
